import { ValueOf } from "@twiliointernal/e2-commons-shared-definitions";

export interface LoggerConfig {
  service: LoggerDataDogServicesType;
  env: string;
}

export const LoggerDataDogServices = {
  OneSupportCenter: "one-support-center",
  WiseOwlZendesk: "wise-owl-zendesk",
} as const;

export type LoggerDataDogServicesType = ValueOf<typeof LoggerDataDogServices>;
